import React, { useState, useEffect } from "react";
import { MagnifyingGlass } from "react-loader-spinner";
import Footer from "./Footer";
import { useMyTenteraService } from "../useMyTenteraService";

const Verifying = (props) => {
  const {
    validationID,
    progressStates,
    // workflowConfig,
    hasMyTenteraFrontCheckCompleted,
    hasMyTenteraBackCheckCompleted,
    // hasSelfieWithMyTenteraCheckCompleted,
    // hasHologramDetectionCheckCompleted,
    onPass,
    onFail,
    onSessionUpdate,
    uiConfig,
  } = props;

  // Safe access
  const global = uiConfig?.Global || {};
  const cardBgColor = global?.card?.backgroundColor || "#f3f4f6"; // gray-50
  const cardOpacity = global?.card?.opacity || "1"; // default opacity
  const pageBgColor = global?.pageContainer?.backgroundColor || "#ffffff"; // white
  const textColor = global?.text?.fontColor || "#6b7280"; // default gray-500

  const { checkResult } = useMyTenteraService();

  const [startVerify, setStartVerify] = useState(false);

  useEffect(() => {
    // const needsSelfieWithMyPR = workflowConfig["Selfie With MyPR"];
    // const needsHologramDetection = workflowConfig["Hologram Detection"];

    const isMyTenteraChecksCompleted =
      (hasMyTenteraFrontCheckCompleted || progressStates.myTenteraFront === "Pass") &&
      (hasMyTenteraBackCheckCompleted || progressStates.myTenteraBack === "Pass");
    // const isSelfieWithMyPRCompleted = needsSelfieWithMyPR
    //   ? hasSelfieWithMyPRCheckCompleted || progressStates.selfieWithMyPR === "Pass"
    //   : true;
    // const isHologramDetectionCompleted = needsHologramDetection
    //   ? hasHologramDetectionCheckCompleted || progressStates.hologramDetection === "Pass"
    //   : true;

    if (isMyTenteraChecksCompleted) {
      setStartVerify(true);
    }
  }, [
    // workflowConfig,
    hasMyTenteraFrontCheckCompleted,
    hasMyTenteraBackCheckCompleted,
    // hasSelfieWithMyTenteraCheckCompleted,
    // hasHologramDetectionCheckCompleted,
  ]);

  useEffect(() => {
    if (progressStates.myTenteraFront === "Pending" || progressStates.myTenteraBack === "Pending") {
      console.log("Start verify");
      setStartVerify(true);
    }
  }, [progressStates]);

  useEffect(() => {
    if (startVerify) {
      verifyDocument();
    }
  }, [startVerify]);

  const verifyDocument = () => {
    checkResult({
      validationID,
    }).then((res) => {
      onSessionUpdate?.(res.session);
      if (res.status === "success") {
        // "Pass" and "In Review" both proceed to next step
        if (res.data.overallStatus === "Pass" || res.data.overallStatus === "In Review") {
          onPass(res.data);
        } else {
          onFail(res.data);
        }
      } else {
        onFail();
      }
      setStartVerify(false);
    });
  };

  return (
    <div
      style={{
        background: pageBgColor,
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        padding: "1rem",
        height: "100%",
      }}
    >
      <div
        style={{
          background: cardBgColor,
          opacity: cardOpacity,
          padding: "2rem",
          borderRadius: "1rem",
          marginTop: "calc(100vh / 16)",
          marginBottom: "2rem",
        }}
      >
        <div className="flex flex-col">
          <p className="text-2xl font-medium">
            Verifying your
            <br />
            <span className="text-blue-700">MyTentera.</span>
          </p>
          <p className="text-gray-500 text-md mt-4">
            Please wait a moment while our secure system processes your information...
          </p>
        </div>
        <div className="flex flex-col items-center mt-8">
          <MagnifyingGlass height="80" width="80" color="#1E3A8A" />
        </div>
      </div>

      <div className="flex flex-1" />

      <Footer
        style={{
          fontSize: "0.75rem",
          color: textColor,
          marginTop: "1rem",
        }}
      />
    </div>
  );
};

export default Verifying;
